import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/一流课程.png';

const _withScopeId = n => (_pushScopeId("data-v-902148c0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "first-class"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "text"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("span", null, "找到61条相关结果")], -1));

const _hoisted_6 = {
  class: "right"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "16",
  height: "16"
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-902148c0><div class=\"content-box\" data-v-902148c0><div class=\"nav\" data-v-902148c0><img src=\"https://img1.baidu.com/it/u=837510728,3756639739&amp;fm=253&amp;app=138&amp;size=w931&amp;n=0&amp;f=JPEG&amp;fmt=auto?sec=1733245200&amp;t=20a28e05371df47d36fc56188f493348\" alt=\"\" width=\"306\" height=\"138\" data-v-902148c0></div><div class=\"botPart\" data-v-902148c0><div class=\"title\" data-v-902148c0><span data-v-902148c0>中国近代史纲要</span></div><div class=\"text\" data-v-902148c0><span data-v-902148c0>张劲</span></div><div class=\"amount\" data-v-902148c0><div data-v-902148c0><span class=\"top\" data-v-902148c0>6391</span><span class=\"bom\" data-v-902148c0>累计选课</span></div><div data-v-902148c0><span class=\"top\" data-v-902148c0>6391</span><span class=\"bom\" data-v-902148c0>累计选课</span></div><div data-v-902148c0><span class=\"top\" data-v-902148c0>6391</span><span class=\"bom\" data-v-902148c0>累计选课</span></div></div></div></div></div>", 1);

import { ref, reactive } from 'vue';
import { firstClassHeaderTab } from './data';
export default {
  setup(__props) {
    const feature = ref();
    const headerNumIndex = ref(0);
    const searchInfo = ref('综合排序');
    const textSelect = reactive([{
      name: '综合排序',
      code: 1
    }, {
      name: '按选课人数降序',
      code: 3
    }, {
      name: '按选课人数升序',
      code: 2
    }]);

    const handleHeaderTab = index => {
      headerNumIndex.value = index;
    }; //切换排序


    function handleSort(item, index) {
      searchInfo.value = item.name;
    }

    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstClassHeaderTab), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(headerNumIndex.value == index ? 'active' : ''),
          onClick: $event => handleHeaderTab(index)
        }, [_createElementVNode("span", null, _toDisplayString(item), 1)], 10, _hoisted_3);
      }), 128))]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_dropdown, {
        trigger: "hover",
        "append-to-body": false,
        "show-arrow": false
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(textSelect), (item, index) => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: item.name,
              onClick: $event => handleSort(item, index)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1032, ["onClick"]);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(searchInfo.value), 1)]),
        _: 1
      })])]), _hoisted_8]);
    };
  }

};